import React, { createContext, useContext, useState, useEffect } from 'react';

const BuyerStatsContext = createContext();

export const useBuyerStats = () => {
  const context = useContext(BuyerStatsContext);
  if (!context) {
    // Fallback wenn Context nicht verfügbar
    return { activeBuyers: 0, newBuyers7d: 0 };
  }
  return context;
};

export const BuyerStatsProvider = ({ children }) => {
  const [stats, setStats] = useState({
    activeBuyers: 0, // Kein Fallback - lädt von API
    newBuyers7d: 0
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/markt-stats-live`);
        if (response.ok) {
          const data = await response.json();
          setStats({
            activeBuyers: data.active_buyers,
            newBuyers7d: data.new_buyers_7d
          });
          console.log('✅ Live Käufer-Stats geladen:', data.active_buyers);
        }
      } catch (error) {
        console.log('Using fallback buyer stats');
      }
    };
    
    fetchStats();
    
    // Aktualisiere alle 5 Minuten
    const interval = setInterval(fetchStats, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <BuyerStatsContext.Provider value={stats}>
      {children}
    </BuyerStatsContext.Provider>
  );
};
